import React, { useState } from "react";
import "../../styles/main.css";
import "../../styles/elements.css";

import GetSelectMonth from "../../Dropdowns/getSelectMonth";
import GetSelectYear from "../../Dropdowns/getSelectYear";

import { getPortabilitySalesData } from "./PortabilityService.js";

const PortabilityReport = () => {
  const [fpsId, setFpsId] = useState("");
  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isOptionsLoading, setIsOptionsLoading] = useState(false);

  const handleSearch = async (e) => {
    e.preventDefault();

    const selectedMonth = document.getElementById("ddlMonth")?.value;
    const selectedYear = document.getElementById("ddlYear")?.value;

    if (!fpsId) {
      setErrorMessage("Please enter FPS ID.");
      return;
    }
    if (!selectedMonth || selectedMonth === "") {
      setErrorMessage("Please select a Month.");
      return;
    }
    if (!selectedYear || selectedYear === "") {
      setErrorMessage("Please select a Year.");
      return;
    }

    setLoading(true);
    setErrorMessage("");
    setReportData([]);

    try {
      const data = await getPortabilitySalesData(
        fpsId,
        selectedMonth,
        selectedYear
      );
      if (data && data.length > 0) {
        setReportData(data);
      } else {
        setErrorMessage("No records found.");
      }
    } catch (error) {
      setErrorMessage("Server connection failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="wrapper100">
      <div className="wrapper row3">
        <div id="container">
          <table
            align="center"
            width="60%"
            style={{ boxShadow: "0 4px 10px 0 rgba(0,0,0,0.2)" }}
          >
            <thead>
              <tr className="tableheader">
                <th colSpan={10}>Portability FPS Sale Search</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <b>FPS ID:</b>
                </td>
                <td>
                  <input
                    type="text"
                    value={fpsId}
                    onChange={(e) => setFpsId(e.target.value)}
                    placeholder="Enter FPS ID"
                  />
                </td>
                <td>
                  <b>Month:</b>
                </td>
                <td>
                  <GetSelectMonth
                    input_id="ddlMonth"
                    onLoadingChange={setIsOptionsLoading}
                  />
                </td>
                <td>
                  <b>Year:</b>
                </td>
                <td>
                  <GetSelectYear
                    input_id="ddlYear"
                    onLoadingChange={setIsOptionsLoading}
                  />
                </td>
              </tr>
              <tr>
                <td colSpan="6" align="center" style={{ padding: "10px" }}>
                  <button
                    onClick={handleSearch}
                    className="button"
                    disabled={loading || isOptionsLoading}
                    style={{
                      cursor: "pointer",
                      backgroundColor: loading ? "#ccc" : "#232323",
                    }}
                  >
                    {loading ? "Searching..." : "Search"}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        {errorMessage && (
          <div
            className="alert-msg error"
            style={{ width: "50%", margin: "10px auto", textAlign: "center" }}
          >
            {errorMessage}
          </div>
        )}
      </div>

      {reportData.length > 0 && (
        <div
          className="wrapper row3"
          style={{ marginTop: "20px", paddingBottom: '150px', minHeight: '100vh' }}
        >
          <table align="center" width="98%" border="1">
            <thead>
              <tr className="tableheader">
                <th colSpan="14">Portability Sales Report</th>
              </tr>

              <tr className="tableheader">
                <th>S.No</th>
                <th>RC No</th>
                <th>Scheme</th>
                <th>Date</th>
                <th>Receipt No</th>

                <th>
                  Wheat
                  <br />
                  (Kg)
                </th>
                <th>
                  Rice
                  <br />
                  (Kg)
                </th>
                <th>
                  F.Rice
                  <br />
                  (Kg)
                </th>
                <th>
                  Sugar
                  <br />
                  (Kg)
                </th>
                <th>
                  Atta
                  <br />
                  (Kg)
                </th>
                <th>
                  PMF Rice
                  <br />
                  (Kg)
                </th>

                <th>Home FPS</th>
                <th>Sale FPS</th>
                <th>District</th>
              </tr>
            </thead>

            <tbody>
              {reportData.map((item, idx) => (
                <tr key={idx}>
                  <td style={{ textAlign: "center" }}>{idx + 1}</td>
                  <td style={{ textAlign: "left", paddingLeft: "5px" }}>
                    {item.rcNo}
                  </td>
                  <td style={{ textAlign: "center" }}>{item.schemeName}</td>
                  <td style={{ textAlign: "center" }}>{item.transDate}</td>
                  <td style={{ textAlign: "center" }}>{item.receiptNo}</td>

                  <td style={{ textAlign: "right", paddingRight: "5px" }}>
                    {item.qtyWheat}
                  </td>
                  <td style={{ textAlign: "right", paddingRight: "5px" }}>
                    {item.qtyRice}
                  </td>
                  <td style={{ textAlign: "right", paddingRight: "5px" }}>
                    {item.qtyFRice}
                  </td>
                  <td style={{ textAlign: "right", paddingRight: "5px" }}>
                    {item.qtySugar}
                  </td>
                  <td style={{ textAlign: "right", paddingRight: "5px" }}>
                    {item.qtyAtta}
                  </td>
                  <td style={{ textAlign: "right", paddingRight: "5px" }}>
                    {item.qtyPmfRice}
                  </td>

                  <td style={{ textAlign: "center" }}>{item.homeFpsId}</td>
                  <td style={{ textAlign: "center" }}>{item.saleFpsId}</td>
                  <td style={{ textAlign: "left", paddingLeft: "5px" }}>
                    {item.saleDistrictName}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default PortabilityReport;
